import { fetchAuthSession } from 'aws-amplify/auth'

// Errors that mean the session is over. Amplify clears its tokens only for
// these, so the user has to sign in again. For any other error, such as a
// network error or a Cognito service error, Amplify keeps the session and
// tries again on the next read. This is the same list Amplify uses in
// TokenOrchestrator.isAuthenticationError.
const SESSION_ENDED_ERRORS = [
  'NotAuthorizedException',
  'TokenRevokedException',
  'UserNotFoundException',
  'PasswordResetRequiredException',
  'UserNotConfirmedException',
  'RefreshTokenReuseException'
]

/**
 * Tells if an error from the token renewal ends the session.
 *
 * @param {Error} [error] - The error Amplify gave.
 * @returns {boolean} True when Amplify has cleared the session for it.
 */
export const isSessionEndedError = error => {
  const name = error?.name || ''

  return SESSION_ENDED_ERRORS.some(endedName => name.startsWith(endedName))
}

/**
 * Reads the tokens of the current Cognito session.
 *
 * Amplify renews the token with the refresh token when it has expired, and
 * makes parallel renewals share one call.
 *
 * @returns {Promise<Object|undefined>} The tokens, or undefined when nobody is
 *   signed in.
 * @throws When the renewal fails, for example on a network error.
 */
export async function readSessionTokens() {
  const { tokens } = await fetchAuthSession()

  return tokens
}
